import { render, staticRenderFns } from "./dialyreport.vue?vue&type=template&id=33c73c6e&scoped=true&"
import script from "./dialyreport.vue?vue&type=script&lang=js&"
export * from "./dialyreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c73c6e",
  null
  
)

export default component.exports